<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">
        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div>
              <h4 class="mb-12 mb-md-0"></h4>
            </div>

            <div class="col-lg-12 col-xl-12 stretch-card">
              <div class="card">
                <div class="card-header">
                  <h4 style="margin-right: 5px" class="float-start">
                    {{ $t("cml_billing") }}
                  </h4>
                  <button
                    v-if="permision_role.method_create"
                    class="btn btn-primary float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="createData()">
                    <i class="link-icon" data-feather="plus"></i>
                    {{ $t("createNew") }}
                  </button>

                  <button
                    v-if="permision_role.method_read"
                    class="btn btn-success float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="downloadData()">
                    <i class="link-icon" data-feather="download"></i>
                    {{ $t("downloadData") }} .xlsx
                  </button>
                </div>

                <div
                  class="card-body"
                  style="text-align: center"
                  v-show="
                    this.roleName !== 'om_cml_basf01' &&
                    this.roleName !== 'om_cml_basf02_rm' &&
                    this.roleName !== 'om_cml_basf02_fg'
                  ">
                  <b
                    ><h3>
                      {{ $t("total_amount") }} :
                      {{ toCurrency(this.sumtotalamountheader) }}
                    </h3></b
                  >
                </div>

                <div class="card-body">
                  <vue-good-table
                    title="list-billing-cml-billing"
                    ref="list-billing-cml-billing"
                    mode="remote"
                    @on-selected-rows-change="selectionChanged"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :totalRows="totalRecords"
                    :line-numbers="true"
                    :isLoading.sync="isLoading"
                    :pagination-options="{
                      enabled: true,
                      perPageDropdown: [10, 50, 100, 1000, 10000],
                      dropdownAllowAll: false,
                    }"
                    :rows="rows"
                    :columns="columns">
                    <template slot="column-filter" slot-scope="{ column }">
                      <span v-if="column.filterOptions.customFilter">
                        <span v-if="column.field == 'transactionFromDate'">
                          <date-range-picker
                            style="width: 100%"
                            @update="fromDatesChange"
                            control-container-class="form-control"
                            :locale-data="{ format: 'yyyy-mm-dd' }"
                            v-model="fromDates"
                            :opens="opens"
                            :singleDatePicker="false"
                            :timePicker24Hour="false"
                            :timePicker="false"
                            :showWeekNumbers="false">
                            <div slot="header" slot-scope="header" class="slot">
                              <a
                                @click="clearfromDatesChange()"
                                class="float-end"
                                style="margin-right: 5px; color: red"
                                >Clear Calendar</a
                              >
                              <span v-if="header.in_selection">
                                - in selection</span
                              >
                              <br />
                            </div>
                          </date-range-picker>
                        </span>
                      </span>
                    </template>

                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'actions'">
                        <a
                          href="#"
                          v-if="permision_role.method_read"
                          title="Detail"
                          @click.prevent="detailData(props.index, props.row)">
                          <i class="mdi mdi-eye" style="font-size: 16px"></i>
                        </a>
                        <a
                          href="#"
                          v-if="
                            permision_role.method_update &&
                            props.row.status == 'DRAFT'
                          "
                          title="Edit"
                          @click.prevent="editData(props.index, props.row)">
                          <i
                            class="mdi mdi-square-edit-outline"
                            style="font-size: 16px"></i>
                        </a>

                        <a
                          href="#"
                          v-if="
                            permision_role.method_delete &&
                            props.row.status == 'DRAFT'
                          "
                          title="Delete"
                          @click.prevent="deleteData(props.index, props.row)">
                          <i
                            class="mdi mdi-trash-can-outline"
                            style="font-size: 16px"></i>
                        </a>
                      </span>
                      <span v-else-if="props.column.field == 'amount'">
                        {{ toCurrency(props.row.amount) }}
                      </span>
                      <span
                        v-else-if="props.column.field == 'transactionFromDate'">
                        {{ props.row.transactionFromDate }} -
                        {{ props.row.transactionToDate }}
                      </span>

                      <span v-else-if="props.column.field == 'status'">
                        <span
                          v-if="props.row.status == 'DRAFT'"
                          class="badge bg-secondary"
                          ><h5>{{ props.row.status }}</h5></span
                        >
                        <span
                          v-else-if="props.row.status == 'COMPLETED'"
                          class="badge bg-success"
                          ><h5>{{ props.row.status }}</h5></span
                        >
                        <span
                          v-else-if="props.row.status == 'CONFIRMED'"
                          class="badge bg-warning"
                          ><h5>{{ props.row.status }}</h5></span
                        >
                        <span
                          v-else-if="props.row.status == 'INTERFACE COMPLETED'"
                          class="badge bg-info"
                          ><h5>{{ props.row.status }}</h5></span
                        >
                        <span
                          v-else-if="
                            props.row.status == 'INTERFACE NOT COMPLETED'
                          "
                          class="badge bg-warning"
                          ><h5>{{ props.row.status }}</h5></span
                        >
                        <span
                          v-else-if="props.row.status == 'SYNC FAILED'"
                          class="badge bg-danger"
                          ><h5>{{ props.row.status }}</h5></span
                        >
                        <span
                          v-else-if="props.row.status == 'INTERFACE FAILED'"
                          class="badge bg-danger"
                          ><h5>{{ props.row.status }}</h5></span
                        >
                        <span v-else class="badge bg-warning"
                          ><h5>{{ props.row.status }}</h5></span
                        >
                      </span>

                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from "vue2-daterange-picker";

export default {
  name: "CmlBillingHeaderBASF02RMIndex",
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    DateRangePicker,
  },
  data() {
    return {
      opens: "center",
      locale: {
        format: "yyyy-mm-dd",
      },
      fromDates: {
        startDate: null,
        endDate: null,
      },
      firstDates: {
        startDate: null,
        endDate: null,
      },
      highlighted: {
        dates: [
          // Highlight an array of dates
          new Date(),
        ],
      },
      sumtotalamountheader: 0,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      isLoading: false,
      errors: [],
      permision_role: [],
      langs: ["id", "en"],
      detailUser: [],
      idBillingHeader: [],
      detailDivisi: [],
      totalRecords: 0,
      transactionFromDate: "",
      firstBilingDate: "",
      transactionToDate: "",
      roleName: "",
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      columns: [
        {
          label: this.$t("idBillingHeader"),
          field: "idBillingHeader",
          width: "100px",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("idBillingHeader"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("idRateHeader"),
          field: "idRateHeader",
          width: "100px",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("idRateHeader"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("fulfillment_code"),
          field: "warehouseId",
          width: "120px",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("fulfillment_code_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("transaction_date"),
          field: "transactionFromDate",
          thClass: "text-center",
          width: "180px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: true,
            placeholder: this.$t("transaction_date"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("rateDesc"),
          field: "rateDesc",
          width: "300px",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("rateDesc"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("tarifMasterId"),
          field: "tarifMasterId",
          width: "100px",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("tarifMasterId"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("statusTxt"),
          field: "status",
          width: "200px",
          thClass: "text-center",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("status_filter_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [
              "DRAFT",
              "PROCESSING",
              "COMPLETED",
              "RECALCULATE",
              "CONFIRMED",
              "INTERFACE NOT COMPLETED",
              "INTERFACE COMPLETED",
              "INTERFACE PROCESSING",
              "SYNC FAILED",
              "INTERFACE FAILED",
            ], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("action_txt"),
          field: "actions",
          thClass: "text-center",
          sortable: false,
          filterOptions: {
            customFilter: false,
            enabled: false,
          },
        },
      ],
      rows: [],
      rowsSelection: [],
    };
  },
  watch: {},
  methods: {
    toCurrency(value) {
      if (typeof value !== "number") {
        return value;
      }
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "IDR",
      });
      return formatter.format(value);
    },

    fromDatesChange() {
      if (this.fromDates.startDate && this.fromDates.endDate) {
        this.transactionFromDate = this.$moment(
          String(this.fromDates.startDate)
        ).format("YYYY-MM-DD");
        this.transactionToDate = this.$moment(
          String(this.fromDates.endDate)
        ).format("YYYY-MM-DD");
        this.loadItems();
      }
    },

    clearfromDatesChange() {
      this.fromDates = {
        startDate: null,
        endDate: null,
      };
      this.transactionFromDate = "";
      this.transactionToDate = "";
      this.loadItems();
    },

    selectionChanged(ev) {
      this.rowsSelection = [];
      this.idBillingHeader = [];
      this.rowsSelection = ev.selectedRows;

      this.rowsSelection.forEach((item) => {
        this.idBillingHeader.push(item.idBillingHeader);
      });
    },

    downloadData() {
      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/hide-rate";
      this.isLoading = true;
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";

      let transactionFromDate = this.transactionFromDate;
      let transactionToDate = this.transactionToDate;

      return this.$http
        .get(
          baseURI +
            `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&warehouseId=${this.serverParams.columnFilters.warehouseId}&customerId=BASF02&rateDesc=RAW MATERIAL&tarifMasterId=${this.serverParams.columnFilters.tarifMasterId}&transactionToDate=${transactionToDate}&transactionFromDate=${transactionFromDate}&status=${this.serverParams.columnFilters.status}&idBillingHeader=${this.serverParams.columnFilters.idBillingHeader}&download=download`,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          this.isLoading = false;
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },

    createData() {
      window.location.href = "/billing-cml/billing/header/create";
    },

    editData(index, row) {
      var params = this.$onRandom(row.idBillingHeader);
      window.location.href = "/billing-cml/billing/header/edit/" + params;
    },

    detailData(index, row) {
      var params = this.$onRandom(row.idBillingHeader);
      window.location.href = "/billing-cml/billing/header/detail/" + params;
    },

    deleteData(index, row, status) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            status: status,
          };
          const baseURI =
            this.$settings.endPointBilling +
            "dashboard/cml-billing/billing/delete/" +
            row.idBillingHeader;
          this.$http
            .delete(baseURI, formData, { timeout: 60000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
        console.log(response);
      });

      this.$logoutUser();
      window.location.href = "/";
    },

    loadItems() {
      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/hide-rate";
      this.isLoading = true;

      let transactionFromDate = this.transactionFromDate;
      let transactionToDate = this.transactionToDate;

      return this.$http
        .get(
          baseURI +
            `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&warehouseId=${this.serverParams.columnFilters.warehouseId}&customerId=BASF02&rateDesc=RAW MATERIAL&tarifMasterId=${this.serverParams.columnFilters.tarifMasterId}&transactionFromDate=${transactionFromDate}&transactionToDate=${transactionToDate}&status=${this.serverParams.columnFilters.status}&idBillingHeader=${this.serverParams.columnFilters.idBillingHeader}`,
          { timeout: 60000 }
        )
        .then((response) => {
          this.isLoading = false;
          this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
          this.sumtotalamountheader = response.data.sumtotalamountheader;
        })
        .catch((error) => {
          this.loading();

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      this.roleName = userDatas.sub.role.name;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "BillingCmlController") {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.loading();
  },
};
</script>
<style scoped>
.blur-content {
  filter: blur(5px);
}
</style>
